import { useTranslation } from "react-i18next";
import { Globe, ChevronDown } from "lucide-react";
import { useState, useRef, useEffect } from "react";
import { SUPPORTED_LANGS } from "../i18n";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = SUPPORTED_LANGS.find((l) => l.code === (i18n.language || "en").split("-")[0]) || SUPPORTED_LANGS[0];

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const change = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="relative" ref={ref} data-testid="language-switcher">
      <button onClick={() => setOpen((v) => !v)} data-testid="btn-lang-toggle"
        className={`inline-flex items-center gap-1.5 ${compact ? "text-xs px-2 py-1" : "text-sm px-3 py-1.5"} rounded-full hover:bg-zinc-100 text-zinc-700 transition-colors`}>
        <Globe size={compact ? 12 : 14} />
        <span className="font-semibold">{current.short}</span>
        <ChevronDown size={compact ? 11 : 12} />
      </button>
      {open && (
        <div className="absolute right-0 mt-1 w-40 bg-white border border-zinc-200 rounded-xl shadow-lg z-30 overflow-hidden" data-testid="lang-menu">
          {SUPPORTED_LANGS.map((l) => (
            <button key={l.code} onClick={() => change(l.code)} data-testid={`lang-option-${l.code}`}
              className={`w-full text-left px-3 py-2 text-sm hover:bg-zinc-50 ${l.code === current.code ? "bg-zinc-50 font-bold text-zinc-950" : "text-zinc-700"}`}>
              {l.label} <span className="text-xs text-zinc-400 ml-1">({l.short})</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
